import * as React from 'react';
import appStore from 'assets/img/landing/app-store.png';
import playStore from 'assets/img/landing/play-store.png';
import styled from 'styled-components';
import {User} from 'modules/utils/User';
import {get} from 'lodash';
import { navigateToBWWLoginScreen } from 'modules/utils';

const SectionWrapper = styled.div`
  background-color: #FFC600;
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'ImpactBold', sans-serif;
  text-transform: uppercase;
  text-align: center;

  font-size: 18px;
  line-height: 38px;

  @media (min-width: 1200px) {
	font-size: 40px;
  }

  @media screen and (max-width: 1000px) {
	padding: 20px 40px;

	h2 {
	  font-family: 'Barlow', sans-serif;
	  font-size: 25px;
	  font-weight: 600;
	  letter-spacing: 0;
	  line-height: 26px;
	}
  }
`;

const Title = styled.h2`
  color: #000000;
  font-family: Champion, sans-serif;
  font-size: 41px;
  letter-spacing: 0;
  line-height: 49px;
  text-align: center;
`;

const LogosWrapper = styled.div`
  display: flex;
  margin-top: 20px;

  a {
	margin: 0 12px;

	@media screen and (max-width: 1000px) {
		margin: 0;
	}
  }

  img {
	height: 35px;

	@media (min-width: 1200px) {
	  height: 65px;
	}

	&:hover {
	  cursor: pointer;
	}

	&:first-child {
	  margin-right: 10px;
	}
  }
`;

const PureButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
`;

export const AppSection: React.FC = () => {
	const user = User.GET_USER_OBJECT();
	const deviseType = get(user, 'device_type');
	const is_app = (deviseType === 'ios' || deviseType === 'android');

	const navigateAuth = () => {
		navigateToBWWLoginScreen('/account/log-in/');
	}

	if (is_app) {
		return (
			<SectionWrapper>
				<PureButton onClick={navigateAuth}>LOGIN TO YOUR ACCOUNT NOW TO PLAY</PureButton>
			</SectionWrapper>
		)
	}

	return (
		<SectionWrapper>
			<Title>DOWNLOAD THE <span>BLAZIN'</span> REWARDS APP</Title>
			<LogosWrapper>
				<a href="https://apps.apple.com/us/app/blazin-rewards/id1031364004" target="_blank"
				   rel="noopener noreferrer">
					<img src={appStore} className="apple-download" alt="App store"/>
				</a>
				<a href="https://play.google.com/store/apps/details?id=com.buffalowildwings.blazinrewards&hl=en"
				   target="_blank" rel="noopener noreferrer">
					<img src={playStore} className="google-download" alt="Play store"/>
				</a>
			</LogosWrapper>
		</SectionWrapper>
	);
};

